module.exports = __webpack_public_path__ + "static/media/kansas_city_team.ce7ed16c.jpg";